import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

// Small "i" icon that reveals an explanation on hover/tap. Self-contained (own provider)
// so it works on pages that don't already wrap content in a TooltipProvider.
export function InfoTip({ text, className = '', side = 'top' }) {
  if (!text) return null;
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid="info-tip-trigger"
            onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
            className={`inline-flex items-center justify-center text-muted-foreground/40 hover:text-blue-400 transition-colors cursor-help ${className}`}
            aria-label="More information"
          >
            <Info className="w-3 h-3" strokeWidth={2} />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-[280px] text-[11px] leading-relaxed font-normal normal-case tracking-normal">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
